import { useEffect, useRef } from 'react';
var signals = new Map();
var subscribeSignals = function (type, handler) {
    var handlers = signals.get(type);
    handlers ? handlers.push(handler) : signals.set(type, [handler]);
};
var unsubscribeSignals = function (type, handler) {
    var handlers = signals.get(type);
    handlers && handlers.splice(handlers.indexOf(handler) >>> 0, 1);
};
export var useSlot = function (type, handler) {
    useEffect(function () {
        subscribeSignals(type, handler);
        return function () { return unsubscribeSignals(type, handler); };
    }, [type, handler]);
};
export var useSignal = function () {
    var signalRef = useRef(function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var handlers = signals.get(type);
        handlers && handlers.map(function (handler) { handler.apply(void 0, args); });
    });
    return signalRef.current;
};
